<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.material.subsupplies')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <MaterialSupplySubForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import MaterialSupplySubForm from '../../components/materialsupplysub/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'MaterialSupplySub';
const routeAfterDel = 'MaterialSupplyUpdate';
const routeAfterDelId = 'materialSupply';

export default {
  name: 'MaterialSupplySubUpdate',
  servicePrefix,
  routeAfterDel,
  routeAfterDelId,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialSupplySubForm
  },

  computed: {
    ...mapFields('materialsupplysub', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('materialsupplysub', ['find'])

  },

  methods: {
    ...mapActions('materialsupplysub', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
